import { json } from "react-router-dom";

export function loader({ params }: { params: { linkCode?: string } }): Response {
  const { linkCode } = params as { linkCode: string };
  return json({ linkCode }, { status: 200 });
}
